import {take, fork, all, call, put} from 'redux-saga/effects';
import * as constants from '../constants';
import * as engineApi from '../services/engineApi';
import {instanceFailure, instanceSuccess, instancePostFailure, instancePostSuccess} from '../actions/action_instance';

function* watchInstanceRequested() {
    while (true) {
        const {payload} = yield take(constants.INSTANCE_REQUESTED);
        try {
            const response = yield call(engineApi.getSurveyInstance, payload.id);
            yield put(instanceSuccess(payload.id, response.data));
        } catch (error) {
            yield put(instanceFailure(payload.id, error));
        }
    }
}

function* watchInstancePostRequested() {
    while (true) {
        const {payload} = yield take(constants.INSTANCE_POST_REQUESTED);
        try {
            const response = yield call(engineApi.postSurveyInstance, payload.id, payload.answers);
            yield put(instancePostSuccess(payload.id, response.data));
        } catch (error) {
            yield put(instancePostFailure(payload.id, error));
        }
    }
}

export default function* instanceSagas() {
    yield all([
        fork(watchInstanceRequested),
        fork(watchInstancePostRequested),
    ]);
}
